var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "13px",
    viewBox: "0 0 12 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn_phone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dealer-Info",
    transform: "translate(-16.000000, -107.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_phone",
    transform: "translate(14.000000, 105.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn_phone"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.666667, 2.666667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 C0,5.89103733 4.77562934,10.6666667 10.6666667,10.6666667 L10.6666667,10.6666667",
    id: "Oval-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.05083057e-14 L4,-7.53122246e-09 L4,3.33333333 L0.775356063,4 C0.275342846,2.76475809 0,1.41453393 0,3.05083057e-14 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6666667,10.6666667 L10.6666667,6.66666667 L7.33333333,6.66666667 L6.66666667,9.8913106 C7.90190858,10.3913238 9.25213274,10.6666667 10.6666667,10.6666667 Z",
    id: "Combined-Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPhone);
export default __webpack_public_path__ + "static/media/icn_phone.ffd70bf57f5fec246f211e29e99db87b.svg";
export { ForwardRef as ReactComponent };